import React, { useContext } from 'react'
import { PageContext } from 'src/utils/context'
import resolveLink from 'src/utils/resolveLink'
import { Link } from 'gatsby'

const CustomBreadcrumbs = ({className, white = false}) => {
    const {
        breadcrumb: { crumbs },
    } = useContext(PageContext)

    return (
        <div className={`${className ? className : ''}`}>
            {crumbs?.map((item, index) => (
                <>
                <Link
                    className={`lg:text-base text-sm duration-300 capitalize 
                        ${index === crumbs.length - 1
                            ? `${white ? 'text-white' : 'text-teal'}`
                            : `${white ? 'text-white opacity-50 hover:opacity-100' : 'text-darkblue-400 hover:text-teal'}`
                        }
                    `}
                    key={index}
                    to={resolveLink(item.pathname)}
                >
                    {item.crumbLabel.replace(/-/g, " ").replace(/_/g, " ")}
                </Link>
                {index < crumbs.length - 1 && <span className={`${white ? 'text-white opacity-50' : 'text-darkblue-400'}`}> / </span>}
                </>
            ))}
            {crumbs[crumbs.length - 1].crumbLabel === "editor" && 
                <p className="text-sm text-warmred font-bold">
                    Breadcrumbs are generated at build time and cannot be viewed in the editor.
                </p>
            }
        </div>
    )
}

export default CustomBreadcrumbs